/* ==========================================================================
   VulkanUS · Video-Karussell (vkcar)  ·  DEV 10, 15.09.2026
   - Endlos-Schleife: die Kartenliste liegt dreimal hintereinander, gestartet
     wird im mittleren Block. Naehert sich die Spur einem Rand, versetzt das
     Skript scrollLeft lautlos um genau eine Blockbreite zurueck.
   - Coverflow: je weiter eine Karte von der Mitte weg ist, desto kleiner,
     dunkler und blasser (--vk-off von 0 bis 1, CSS macht den Rest).
   - Video laedt erst beim Klick. Im Ruhezustand haengt nur ein Poster-<img>
     im DOM, das spart auf Seiten mit vielen Clips mehrere Megabyte.

   Fallstricke, die hier bewusst geloest sind:
   - requestAnimationFrame pausiert in Hintergrund-Tabs komplett. Wer den Shop
     per "Link in neuem Tab" oeffnet, saehe sonst ein Karussell, das im
     Startzustand haengenbleibt. Darum laeuft jeder rAF zusaetzlich ueber einen
     Timer (raf() unten) und paint() wird immer auch synchron aufgerufen.
   - scroll-snap + programmatisches Scrollen: der Browser zieht sonst zurueck.
     Waehrend jeder eigenen Animation und jedem Sprung ist Snap darum aus.
   - Das automatische Zentrieren beim Start hoert auf, sobald der Besucher
     selbst wischt — sonst reisst es ihn nach einer Sekunde zurueck.
   ========================================================================== */
(function () {
  if (window.__vkCarousel) return;
  window.__vkCarousel = true;

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SETS = 3;

  /* rAF mit Timer-Netz: laeuft auch, wenn der Tab im Hintergrund liegt */
  function raf(fn) {
    var done = false;
    function run() { if (done) return; done = true; fn(); }
    if (typeof requestAnimationFrame === 'function') requestAnimationFrame(run);
    setTimeout(run, 60);
  }

  function play(card) {
    var src = card.getAttribute('data-video');
    if (!src) return;
    document.querySelectorAll('.vkcar__item.is-playing').forEach(function (o) {
      if (o === card) return;
      var ov = o.querySelector('video');
      if (ov) ov.pause();
      o.classList.remove('is-playing');
    });
    var v = card.querySelector('video');
    if (!v) {
      v = document.createElement('video');
      v.setAttribute('playsinline', '');
      v.setAttribute('loop', '');
      v.setAttribute('preload', 'auto');
      var poster = card.getAttribute('data-poster');
      if (poster) v.setAttribute('poster', poster);
      v.src = src;
      var img = card.querySelector('img');
      if (img) img.style.display = 'none';
      card.insertBefore(v, card.firstChild);
    }
    if (v.paused) {
      v.muted = false;
      var p = v.play();
      if (p && p.catch) p.catch(function () { v.muted = true; v.play(); });
      card.classList.add('is-playing');
    } else {
      v.pause();
      card.classList.remove('is-playing');
    }
  }

  function setup(track) {
    if (track.__vkcar) return;
    track.__vkcar = true;

    var wrap = track.closest('.vkcar-wrap') || track.parentNode;
    var originals = Array.prototype.slice.call(track.children);
    if (!originals.length) return;

    var loop = originals.length >= 4;
    if (loop) {
      for (var s = 1; s < SETS; s++) {
        originals.forEach(function (el) {
          var c = el.cloneNode(true);
          c.setAttribute('data-vkcar-clone', '1');
          c.removeAttribute('id');
          track.appendChild(c);
        });
      }
    }

    var touched = false;   // hat der Besucher selbst gescrollt/gewischt?
    var jumping = false;

    function cards() { return track.querySelectorAll('.vkcar__item'); }

    function unlock() {
      track.classList.remove('is-jumping');
      jumping = false;
    }

    function blockWidth() {
      var all = cards();
      if (!all.length || !loop) return 0;
      var per = Math.round(all.length / SETS);
      if (!all[per]) return 0;
      return all[per].offsetLeft - all[0].offsetLeft;
    }

    function wrapAround() {
      if (!loop || jumping) return;
      var w = blockWidth();
      if (!w) return;
      var x = track.scrollLeft, target = null;
      if (x < w * 0.5) target = x + w;
      else if (x > w * 1.5) target = x - w;
      if (target === null) return;
      jumping = true;
      track.classList.add('is-jumping');
      track.scrollLeft = target;
      paint();
      raf(unlock);
    }

    function paint() {
      var box = track.getBoundingClientRect();
      if (!box.width) return;
      var mid = box.left + box.width / 2;
      var all = cards();
      /* Reichweite des Verlaufs: mindestens knapp zwei Kartenbreiten, sonst
         steht der direkte Nachbar auf dem Handy sofort auf ganz dunkel. */
      var cw = all.length ? all[0].offsetWidth : 240;
      var cs0 = getComputedStyle(track);
      var gp = parseFloat(cs0.columnGap || cs0.gap || '18') || 18;
      var span = Math.max(box.width * 0.42, (cw + gp) * 1.7);
      var best = null, bestD = Infinity;
      for (var i = 0; i < all.length; i++) {
        var r = all[i].getBoundingClientRect();
        var d = Math.abs((r.left + r.width / 2) - mid);
        var off = Math.min(1, d / span);
        all[i].style.setProperty('--vk-off', off.toFixed(3));
        if (d < bestD) { bestD = d; best = all[i]; }
        all[i].classList.remove('is-center');
      }
      if (!best) return;
      best.classList.add('is-center');
      var counter = wrap.querySelector('[data-vkcar-count]');
      if (counter) {
        var idx = parseInt(best.getAttribute('data-idx'), 10);
        var total = parseInt(track.getAttribute('data-total'), 10) || originals.length;
        if (!isNaN(idx)) counter.textContent = (idx + 1) + ' / ' + total;
      }
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      raf(function () { paint(); wrapAround(); ticking = false; });
    }, { passive: true });

    /* eigene Scroll-Animation — smooth und snap vertragen sich nicht */
    function animateTo(target, dur) {
      var start = track.scrollLeft;
      var delta = target - start;
      if (!delta) return;
      if (REDUCED || document.hidden) {
        track.scrollLeft = target; paint(); wrapAround(); return;
      }
      var t0 = null, done = false;
      track.classList.add('is-jumping');
      function finish() {
        if (done) return;
        done = true;
        unlock();
        paint(); wrapAround();
      }
      function step(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        track.scrollLeft = start + delta * (1 - Math.pow(1 - p, 3));
        paint();
        if (p < 1) requestAnimationFrame(step); else finish();
      }
      requestAnimationFrame(step);
      setTimeout(finish, dur + 260);
    }

    function stepBy(dir) {
      var all = cards();
      if (!all.length) return;
      touched = true;
      var w = all[0].getBoundingClientRect().width;
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap || '18') || 18;
      animateTo(track.scrollLeft + dir * (w + gap), 380);
    }

    wrap.querySelectorAll('[data-vkcar-prev]').forEach(function (b) {
      b.addEventListener('click', function () { stepBy(-1); });
    });
    wrap.querySelectorAll('[data-vkcar-next]').forEach(function (b) {
      b.addEventListener('click', function () { stepBy(1); });
    });

    /* Ziehen mit der Maus */
    var down = false, moved = 0, sx = 0, sl = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true; moved = 0; touched = true;
      sx = e.clientX; sl = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      moved = Math.max(moved, Math.abs(dx));
      track.scrollLeft = sl - dx;
      e.preventDefault();
    });
    function endDrag() {
      if (!down) return;
      down = false;
      track.classList.remove('is-dragging');
      wrapAround();
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', endDrag);
    track.addEventListener('touchstart', function () { touched = true; }, { passive: true });
    track.addEventListener('wheel', function () { touched = true; }, { passive: true });

    /* Klick und Tastatur */
    track.addEventListener('click', function (e) {
      var card = e.target.closest('.vkcar__item');
      if (!card) return;
      if (moved > 8) { moved = 0; return; }
      play(card);
    });
    track.addEventListener('keydown', function (e) {
      var card = e.target.closest('.vkcar__item');
      if (!card) return;
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); play(card); }
      if (e.key === 'ArrowRight') { e.preventDefault(); stepBy(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); stepBy(-1); }
    });

    /* Startposition: erste Karte des mittleren Blocks mittig */
    function center(force) {
      if (touched && !force) { paint(); return; }
      var all = cards();
      if (!all.length || !track.clientWidth) return;
      var el = all[loop ? Math.round(all.length / SETS) : 0] || all[0];
      track.classList.add('is-jumping');
      track.scrollLeft = el.offsetLeft - (track.clientWidth - el.clientWidth) / 2;
      paint();
      raf(unlock);
    }

    center();
    [80, 300, 900].forEach(function (ms) { setTimeout(function () { center(); }, ms); });
    window.addEventListener('load', function () { center(); });
    window.addEventListener('resize', function () { paint(); });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) { unlock(); center(); }
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { unlock(); center(); } });
      }, { rootMargin: '300px 0px' }).observe(track);
    }
  }

  function boot() { document.querySelectorAll('[data-vkcar]').forEach(setup); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function () { setTimeout(boot, 60); });
})();
